import api from "services/api";
import type { DreGerencialApiResponse } from "../types/dre-gerencial.types";
import type { DashboardFinanceiroParams } from "../types/financeiro-dashboard.types";
import { granularidadeParaApi } from "../helpers/granularidade-api";

export async function obterDREGerencial(
  params?: DashboardFinanceiroParams,
): Promise<{ data: DreGerencialApiResponse | null; status: number }> {
  const search = new URLSearchParams();
  if (params?.dataInicio) search.set("dataInicio", params.dataInicio);
  if (params?.dataFim) search.set("dataFim", params.dataFim);
  if (params?.granularidade) {
    search.set("granularidade", granularidadeParaApi[params.granularidade]);
  }
  const qs = search.toString();
  const url = `/loja/financeiro/dre-gerencial${qs ? `?${qs}` : ""}`;
  const res = await api.get<DreGerencialApiResponse>(url);
  const status = res.status;
  if (status !== 200) {
    return { data: null, status };
  }
  return { data: res.data ?? null, status };
}
